import React from 'react';
import { Layout, Select } from 'antd';
// import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

const { Option } = Select;


const Header = props => {
  return (
    <Layout.Header className="header-wrapper" style={{background :  props.background || '#4c48bd'}}>
      <div className="header-box">
        <Link to="./home">
          <img src={require('../img/logo.svg')} alt="mojitok-logo" className="logo"/>
        </Link>
        {/* <div className="select-language-box">
          <Select onChange={(value) => props.changeLanguage(value)} defaultValue={props.defaultLanguage}>
            <Option value="en">
              <FormattedMessage id="langauge-en" defaultMessage="English"/>
            </Option>
            <Option value="ko">
              <FormattedMessage id="langauge-ko" defaultMessage="Korean"/>
            </Option>
          </Select>
        </div> */}
      </div>
    </Layout.Header>
  );
}

export default Header;
